import { isPlatform } from '@ionic/react';
import { WalkI } from './../interfaces/Walk';
import { removeUser } from './../redux/actions/logInActions';
import WebSocketClient from "../services/WebSocketClient";
import history from '../helpers/history';
import Api from "../services/Api";
import { SocialSharing } from '@ionic-native/social-sharing'
import { formatEnd } from './format_date';
import dayjs from 'dayjs'

const api = Api.getInstance()
const webSocketClient = WebSocketClient.getInstance();

export const goBack = () => {
  history.go(-1)
}

export const goToPage = (url: string) => {
  history.push({
    pathname: url,
  })
}

export const goToPageWithState = (url: string, state: any) => {
  history.push({
    pathname: url,
    state: state
  })
}

export const saveProfile = async (data: SaveProfileInterface): Promise<any> => {
  return new Promise (resolve => {
    api.post('/profile/save', data).then(res => {
      res.json().then(data => {
        // console.log(data)
        if (data.status === 'ok') {
          // console.log(data, 'success')
          resolve(true)
        } else {
          alert('Ändring misslyckades: ' + data.message);
        }
      })
    })
  })
}

export const logOut = () => {
  removeUser()
  webSocketClient.sendEvent('session', { type: 'logout' })
}

interface SaveProfileInterface {
  first_name: string
  last_name: string
  email: string
  password: string
  picture: string
  biography: string | null
}

 export const IsJsonString = (str: string) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
  }


export const shareNoteEmail = (view: string, walk: WalkI, notes: any) => { 
  const message = createDocument(view, walk, notes)
  const subject = 'Walking Talking - ' + walk.name + ' - Delade anteckningar'
  const to = ['']

  if(isPlatform('capacitor')) {
    SocialSharing.shareViaEmail(message, subject, to)
  } else {
    
  }
}

export const createDocument = (view: string, walk: WalkI, notesResult: any) => {
  let notes = view === 'private' ? 'Privata anteckningar' : 'Delade anteckningar'
  // const availableTo = walk.booked && walk.bookedPersons.length > 0 ? walk.bookedPersons.map(person => person.firstName) : walk.bookedPerson?.firstName
  const link = 'https://app.walkingtalking.com/walk/walk/' + walk.id
  let list = notesResult

  if(view === 'agenda') {
    notes = 'Agenda'
    list = notesResult.filter((note: any) => note.noteType === 1)
  } else {
    list = notesResult.filter((note: any) => note.noteType === 0).reverse()
  }
  let email =`"${walk.name}" - ${dayjs(walk.start).format('YY/MM/DD HH:mm')}-${formatEnd(walk.start, walk.lengthMinutes)} \n \t \n \t ${link} \n\n ${walk.description} \n\n` +  notes + ':\n\n' 

  for(let i = 0; list.length > i; i++) {
    const text = list[i].text
    const createdBy = list[i].person.firstName
    const created =  dayjs(list[i].createdAt).locale(api.lang).format('DD MMMM HH:mm')
    if(view === 'agenda'){
      const json = JSON.parse(list[i].json)
      email += `"${text} ${json.list.map((obj: any) => '\n' + '- ' + obj.subject  ).join('')}" \n \n ${createdBy}, ${created} \n \n`
    } else {
      email += `"${text}" \n ${createdBy}, ${created} \n \n `
    }
  }

  return email
}

export const shareNoteGoogle = (view: string, walk: WalkI, notesResult: any) => { 
  const message = createDocument(view, walk, notesResult)
  const subject = 'Walking Talking - ' + walk.name + ' - Delade anteckningar'

  if(isPlatform('capacitor')) {
    SocialSharing.share(message, subject)
  } else {
    // console.log('desktop yo', createDocument(view, walk, notesResult))
  }
}

 export const shareNote = (noteData: any, walk: WalkI) => {
  const message = noteData.text + '\n' + 'Created by: ' + noteData.person.firstName
  const subject = 'Walking Talking - ' + walk.name + ' - Anteckning'
  const url = ''

  if(isPlatform('capacitor')) {
    SocialSharing.share(message, subject, undefined, url)
  } else {
    // console.log('not capacitor')
  }
}

export const shareAllNotes = (view: string, walk: WalkI, notesResult: any) => {
  const message = createDocument(view, walk, notesResult)
  const subject = 'Anteckningar delas'
  const url = ''
  SocialSharing.share(message, subject, undefined, url)
}